document.addEventListener('ShoptetRatingModalOpened', function() {
        const productName = $('.p-detail-inner-header').first().find('h1').html() || '';
        const productNameAlt = $('.p-detail-inner-header').first().find('h1').text() || '';
        const $ratingWrap = $(this).closest('#ratingWrapper');
        const canRate = $('.ratingDialog #ratingWrapper').length;
        const productId = $('#product-detail-form meta[itemprop="productID"]').attr('content') || '';
        const ratingValueRaw = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingValue"]').attr('content');
        const ratingValue = ratingValueRaw ? ratingValueRaw.replace('.', ',') : 0;
        const ratingCountRaw = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingCount"]').attr('content');
        const ratingCount = ratingCountRaw || 0;
        const popupContent = canRate;
        if($('.rating-star-description').length){
            $('#dialogFormRating .rating-stars-group').prepend(`
                <div class="h6"><img src="${$('.p-image .p-main-image').attr('href')}" alt="${productNameAlt.trim()}"><span>${productName.trim()}</span></div>
            `)
            $('#dialogFormRating #rating-stars-label span').html(`Zvolte počet hvězd. Vaše hodnocení pomůže ostatním zákazníkům s výběrem zboží. Hodnocení produktu je <strong>${ratingValue} z 5</strong>. Děkujeme.`)
            $('.ratingDialog #ratingWrapper').hide()
        }
        else{
            $('.ratingDialog #ratingWrapper').replaceWith(`
                <div class="h6"><img src="${$('.p-image .p-main-image').attr('href')}" alt="${productNameAlt.trim()}"><span>${productName.trim()}</span></div>
                <div class="ratingdone">
                    Děkujeme. U tohoto produktu jste již hlasovali. Aktuální hodnocení produktu je <strong>${ratingValue} z 5</strong>.
                </div>
            `)
           
        };
        
        $(function () {
            $('.rating-stars-wrapper').each(function () {
                var $wrapper = $(this);

                $wrapper.find('.rating-star').on('mouseenter', function () {
                    var value = parseInt($(this).find('input[name="score"]').val(), 10);

                    setRatingStars($wrapper, value);
                });

                $wrapper.find('input[name="score"]').on('change', function () {
                    var value = parseInt($(this).val(), 10);

                    setRatingStars($wrapper, value);
                });

                $wrapper.on('mouseleave', function () {
                    var checkedValue = parseInt($wrapper.find('input[name="score"]:checked').val(), 10);

                    if (checkedValue) {
                        setRatingStars($wrapper, checkedValue);
                    } else {
                        resetRatingStars($wrapper);
                    }
                });
            });

            function setRatingStars($wrapper, value) {
                $wrapper.find('.rating-star').each(function () {
                    var $star = $(this);
                    var starValue = parseInt($star.find('input[name="score"]').val(), 10);

                    $star.removeClass('full hoverEmpty');

                    if (starValue <= value) {
                        $star.addClass('full');
                    } else {
                        $star.addClass('hoverEmpty');
                    }
                });
            }

            function resetRatingStars($wrapper) {
                $wrapper.find('.rating-star').removeClass('full hoverEmpty');
            }
        });
         shoptet.modal.resize();
        setTimeout(function(){
           
        })

       
    });
    

 $('.product-top .star').each(function () {
    const $star = $(this);
    const $ratingWrap = $star.closest('.stars-wrapper');
    if ($star.hasClass('productRatingAction')) {
      $ratingWrap.attr('data-can-rate', '1');
    }
    $star.removeClass('productRatingAction');
  });
  $('.product-top .stars-wrapper').each(function () {
    const $ratingWrap = $(this);
    if (!$ratingWrap.attr('data-can-rate')) {
      $ratingWrap.attr('data-can-rate', '0');
    }
  });

  $('html').on('click', '.product-top .stars-wrapper span', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $ratingWrap = $(this).closest('.stars-wrapper');
    const canRate = $ratingWrap.attr('data-can-rate') === '1';
    const productId = $('#product-detail-form meta[itemprop="productID"]').attr('content') || '';
    const productName = $('.p-detail-inner-header').first().find('h1').html() || '';
    const productNameAlt = $('.p-detail-inner-header').first().find('h1').text() || '';
    const ratingValueRaw = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingValue"]').attr('content');
    const ratingValue = ratingValueRaw ? ratingValueRaw.replace('.', ',') : 0;
    const ratingCountRaw = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingCount"]').attr('content');
    const ratingCount = ratingCountRaw || 0;
    const popupContent = canRate
      ? `
        <div class="customStarsWrap">
          <span class="customStar" data-productid="${productId}" data-score="1"></span>
          <span class="customStar" data-productid="${productId}" data-score="2"></span>
          <span class="customStar" data-productid="${productId}" data-score="3"></span>
          <span class="customStar" data-productid="${productId}" data-score="4"></span>
          <span class="customStar" data-productid="${productId}" data-score="5"></span>
        </div>
        <div class="customStarsText">Vyberte hodnocení</div>
      `
      : `
        <div class="customStarsAlreadyRated">
          <p>U tohoto produktu jste již hlasovali.</p>
        </div>
      `;

    $.colorbox({
      html: `
        <div class="colorboxPopupRatings">
          <div class="h3">Hodnocení produktu</div>
          <div class="h6"><img src="${$('.p-image .p-main-image').attr('href')}" alt="${productNameAlt.trim()}"><span>${productName.trim()}</span></div>
          <p>
            ${
              canRate
                ? `Zvolte počet hvězd. Vaše hodnocení pomůže ostatním zákazníkům s výběrem zboží. Hodnocení produktu je <strong>${ratingValue} z 5</strong>. Děkujeme.`
                : `Děkujeme. U tohoto produktu jste již hlasovali. Aktuální hodnocení produktu je <strong>${ratingValue} z 5</strong>.`
            }
          </p>

          ${popupContent}
        </div>
      `,
      height: '380px',
      width: '500px',
      maxWidth: '90%',
      maxHeight: '90%',
      onComplete: function () {
        initTooltips();
      }
    });

    return false;
  });